import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (AuthService.getUser() && AuthService.getUser().isMasterUser) {
                return next()
            }

            next({ name: 'index' })
        })
    },
}
